import React from 'react';
import ModalAlert from '../components/ModalAlert';


function BelayRequest() {
  return (
    <div>BelayRequest
      <ModalAlert/>

      
    </div>
  )
}

export default BelayRequest